package koala.css

// utilities
val Magic = CssUtility("magic")
val Reveal = CssUtility("reveal")
val Hide = CssUtility("hide")
val Blur = CssUtility("blur")
val SlideLeft = CssUtility("slide-left")
val SlideUp = CssUtility("slide-up")
val SlideRight = CssUtility("slide-right")
val SlideDown = CssUtility("slide-down")
val Scale = CssUtility("scale")